var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlineCreditCardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fpvjowgx2a",
    d: "M18 4c2.21 0 4 1.79 4 4v8c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V8c0-2.21 1.79-4 4-4zm2 7H4v5c0 1.054.816 1.918 1.85 1.995L6 18h12c1.105 0 2-.895 2-2v-5zM8 14c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L8 16H7c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L7 14h1zm5 0c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L13 16h-1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L12 14h1zm5-8H6c-1.105 0-2 .895-2 2v1h16V8c0-1.054-.816-1.918-1.85-1.995L18 6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#37c0ca",
    fillRule: "nonzero",
    xlinkHref: "#fpvjowgx2a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineCreditCardBlue);
export default __webpack_public_path__ + "static/media/icon-outline-credit-card-blue.abebbc1de810dccb11675be2c0989a51.svg";
export { ForwardRef as ReactComponent };